/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coaching_Pdf_GeneratedInputs */

const en_us2_coaching_pdf_generated = /** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created on ${i?.date} by MyPocketGym`)
};

const pt_br2_coaching_pdf_generated = /** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerado em ${i?.date} pelo MyPocketGym`)
};

const pt_pt2_coaching_pdf_generated = /** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerado em ${i?.date} pelo MyPocketGym`)
};

/** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */
const es_419_coaching_pdf_generated = en_us2_coaching_pdf_generated;

/** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */
const fr_fr2_coaching_pdf_generated = en_us2_coaching_pdf_generated;

/** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */
const de_de2_coaching_pdf_generated = en_us2_coaching_pdf_generated;

/** @type {(inputs: Coaching_Pdf_GeneratedInputs) => LocalizedString} */
const it_it2_coaching_pdf_generated = en_us2_coaching_pdf_generated;

/**
* | output |
* | --- |
* | "Created on {date} by MyPocketGym" |
*
* @param {Coaching_Pdf_GeneratedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pdf_generated = /** @type {((inputs: Coaching_Pdf_GeneratedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pdf_GeneratedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pdf_generated(inputs)
	if (locale === "es-419") return es_419_coaching_pdf_generated(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pdf_generated(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pdf_generated(inputs)
	if (locale === "de-DE") return de_de2_coaching_pdf_generated(inputs)
	if (locale === "it-IT") return it_it2_coaching_pdf_generated(inputs)
	return en_us2_coaching_pdf_generated(inputs)
});
export { coaching_pdf_generated as "coaching.pdf_generated" }